import { render, staticRenderFns } from "./TSGBrauchwasser.vue?vue&type=template&id=4b8e000f&"
import script from "./TSGBrauchwasser.vue?vue&type=script&lang=ts&"
export * from "./TSGBrauchwasser.vue?vue&type=script&lang=ts&"
import style0 from "./TSGBrauchwasser.vue?vue&type=style&index=0&id=4b8e000f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports